// Copyright (c) 2018 Deere & Company

import PartReturn from '@deere/cps-it.warranty-model-factory/lib/part-return';

export const createRequestPayload = (form, partReturn) =>
    new PartReturn({
        ...partReturn,
        ...form
    });



// WEBPACK FOOTER //
// ./src/part-requests/request-details/services/create-payload.js